import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {httpGetMedicalReportType} from '../http/medicalReports.http'
import {QUERY_KEYS} from '@/queryClient'
import {MedicalReportType} from '@/types'

export const useGetMedicalReportType = ({
    urlParams,
    options
}: {
    urlParams: {id: string}
    options?: Omit<UseQueryOptions<MedicalReportType>, 'queryKey' | 'queryFn'>
}) => {
    return useQuery({
        queryKey: [QUERY_KEYS.MEDICAL_REPORT_TYPES, urlParams.id],
        queryFn: () => httpGetMedicalReportType({urlParams}),
        ...options
    })
}
